import { render, staticRenderFns } from "./bankong.vue?vue&type=template&id=7edc3b84"
import script from "./bankong.vue?vue&type=script&lang=js"
export * from "./bankong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports